import React, { useState, useEffect, useRef } from "react";
import "../../../../css/bs-stepper.css";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { IconSmartHome, IconCategory, IconPhoto, IconBuilding, IconPalette } from '@tabler/icons-react';
import "../../MyInvitations/Common/FormCss.css";
import { useAuth } from "../../../Context/store/context";
import StepHeader from "../../MyInvitations/Common/Step-Header";
import { _get } from "../../../../apiClient";
import { _showToast } from "../../../../toastHelper";
import { fetchadmininfo } from "../../../Redux/Actions/AdmininfoAction";
import globals from "../../../../globals";
import DemoDetails from "./Demo-Details/DemoDetails";
import Categories from "./Categories/Categories";
import Studios from "../../MyInvitations/Common/Studio/Studios";
import ThemeCustomization from "../../MyInvitations/Common/Customization/ThemeCustomization";
import Products from "./Products/Products";
import Save from "./Save";
import FetchAndBindData from "./BindData";

export default function DemoForm() {
  const navigate = useNavigate();
  const { themeId, id } = useParams();
  const { showLoader, hideLoader, getToken, updateTitleAndIcon, logoutuser } = useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const dispatch = useDispatch();
  const [deletedImages, setDeletedImages] = useState([]);
  const [categories, setCategories] = useState([]);

  const eventSections = [
    {
      title: "Demo Details", subTitle: "", data: null, isValid: false, sectionname: "demo",
      icon: function () {
        return <IconSmartHome size={22} />
      }
    },
    {
      title: "Categories", subTitle: "", data: null, isValid: false, sectionname: "categories",
      icon: function () {
        return <IconCategory size={22} />
      }
    },
    {
      title: "Products", subTitle: "", data: null, isValid: false, sectionname: "products",
      icon: function () {
        return <IconPhoto size={22} />
      }
    },
    {
      title: "Studio Profile", subTitle: "", data: null, isValid: false, sectionname: "studio",
      icon: function () {
        return <IconBuilding size={22} />
      }
    },
    {
      title: "Customization", subTitle: "", data: null, isValid: false, sectionname: "theme",
      icon: function () {
        return <IconPalette size={22} />
      }
    }
  ];

  const [sections, setSections] = useState([]);
  const [eventId, setEventId] = useState(0);
  const [eventCode, setEventCode] = useState("");
  const [currentStep, setCurrentStep] = useState(0);
  const childRef = useRef();

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.demo.title, globals.demo.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      if (id) {
        fetchandBindData(id);
      }
      else
        setSections(eventSections);
    }
  }, [userDetails, id]);

  const fetchandBindData = async (id) => {
    let result = await FetchAndBindData(id, eventSections);
    if (result) {
      setSections(result.sections);
      setEventId(result.eventId);
      setEventCode(result.eventCode);
      result.sections.forEach(element => {
        if (element.sectionname == "categories") {
          setCategories(element["data"]);
        }
      });
    }
    else
      return navigate("/demos");
  }

  const handleSectionClick = (e, step) => {
    e.preventDefault();
    if (validateForm()) {
      let nextStep = currentStep + 1;
      while (nextStep < step) {
        if (sections[nextStep].isValid)
          nextStep++;
        else {
          let section = sections[nextStep];
          _showToast("Please provide information in " + section.title + " section", "warning");
          return;
        }
      }
      getAndUpdateData();
      setCurrentStep(step);
    } else {
      _showToast("Please provide information for all the required fileds before proceeding further", "warning");
    }
  };

  const insertDeletedImage = (imageKey) => {
    setDeletedImages(current => [...current, imageKey]);
  }

  const renderStep = () => {
    if (sections && sections.length > 0) {
      const section = sections[currentStep];
      switch (section.sectionname) {
        case "demo":
          return (<DemoDetails ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "categories":
          return (<Categories ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "products":
          return (<Products ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} categories={categories} />);
        case "studio":
          return (<Studios ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} imageDelete={insertDeletedImage} />);
        case "theme":
          return (<ThemeCustomization ref={childRef} data={section.data} index={currentStep} steps={sections.length} navigate={handleSectionClick} save={saveHandler} imageDelete={insertDeletedImage} />);
      }
    }
  };

  const validateForm = () => {
    sections[currentStep].isValid = childRef?.current?.validate() ?? false;
    return sections[currentStep].isValid;
  }

  const getAndUpdateData = () => {
    const updatedSections = [...sections];
    updatedSections[currentStep]["data"] = childRef?.current?.getData() ?? null;
    setSections(updatedSections);
    const section = updatedSections[currentStep];
    if (section.sectionname == "categories") {
      setCategories(updatedSections[currentStep]["data"]);
    }
  }

  const saveHandler = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      getAndUpdateData();
      showLoader();
      if (await checkStatus()) {
        let result = await Save([...sections], themeId, eventId, eventCode, deletedImages);
        hideLoader();
        if (result.status == "success") {
          if (!eventId || (eventId && eventId == 0))
            updateDemoCount();

          setEventCode(result.eventCode);
          setEventId(result.eventId);

          window.history.replaceState(null, "Edit Demo | Invitd", "/demos/" + result.eventId);
          window.open(result.eventUrl, "_blank");
          _showToast(result.message, "success");
        }
        else {
          if (result.message != "")
            _showToast(result.message, "error");
        }
      }
    }
    else {
      _showToast("Please provide information for all the required fileds before proceeding further", "warning");
    }
  }

  const checkStatus = async () => {
    if (!eventId || (eventId && eventId == 0)) {
      return await _get(`/events/check-status?isForDemo=true`)
        .then(async () => {
          return true;
        })
        .catch((error) => {
          hideLoader();
          _showToast(error, "error");
          return false;
        });
    }
    else
      return true;
  }

  const updateDemoCount = () => {
    userDetails.eventCount = userDetails.eventCount + 1;
    dispatch(fetchadmininfo(userDetails));
  }

  return (
    <div className="content-wrapper container-xxl flex-grow-1 container-p-y  ">
      <div className="card mb-3">
        <div className="card-body">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-style1 mb-0">
              <li className="breadcrumb-item ">
                <NavLink to="/dashboard" className="text-gray">
                  Dashboard
                </NavLink>
              </li>
              <li className="breadcrumb-item">
                <NavLink className="text-gray" to="/demos">
                  My Demos
                </NavLink>
              </li>
              {eventId == 0 && (
                <>
                  <li className="breadcrumb-item">
                    <NavLink className="text-gray" to={"/create-demo/themes/"}>
                      Select Theme
                    </NavLink>
                  </li>
                  <li className="breadcrumb-item text-primary">Demo</li>
                </>)}

              {eventId > 0 && (
                <li className="breadcrumb-item text-primary">Edit Demo</li>
              )}
            </ol>
          </nav>
        </div>
      </div>

      <div className="bs-stepper wizard-vertical wizard-numbered vertical mt-2">
        <div className="bs-stepper-header">
          {sections.map((section, index) => {
            const isActive = index === currentStep;
            let backgroundcolor = "text-gray";

            if (isActive) {
              backgroundcolor = "text-red";
            } else if (section.isValid) {
              backgroundcolor = "text-green";
            }

            return <StepHeader backgroundColor={backgroundcolor}
              Icon={section.icon}
              title={section.title}
              subTitle={section.subTitle}
              className={`step ${isActive ? "active" : ""}`}
              onClick={(e) => handleSectionClick(e, index)}
              key={index} />
          })}
        </div>
        <div className="bs-stepper-content">{renderStep()}</div>
      </div>
    </div>
  );
}
